// src/hooks/useUserProfile.ts

import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export interface ProfileData {
  id: string;
  name: string;
  email: string;
  imageUrl: string;
  userType: number;
}

export const useUserProfile = (token: string | null) => {
  const [profile, setProfile] = useState<ProfileData>({
    id: "",
    name: "Someone Name",
    email: "someone@gmail.com",
    imageUrl: "/frontend/images/user.jpg",
    userType: 0,
  });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/authuser/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data.success) {
          const p = res.data.profile;
          setProfile({
            id: p.us_id || "",
            name: p.us_name || "",
            email: p.us_email || "",
            imageUrl: p.us_profileimage
              ? `${API_BASE}/uploads/profiles/${p.us_profileimage}`
              : "/frontend/images/user.jpg",
            userType: p.us_usertype || 0,
          });
        } else {
          console.log("Profile API returned no success");
        }
      } catch (err) {
        console.log("Using dummy profile because API not available");
      }
    };

    if (token) {
      fetchProfile();
    }
  }, [token]);

  return profile;
};
